module.exports = __webpack_public_path__ + "static/media/Will Secor.e4f240a2.png";